'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { TextArea } from 'foundations-components/transitional/components/TextArea';
import { SHARE_EMAIL } from '../shareTypes';
import { useControlsContext } from '../context';
import { getEventValue } from '../../../utils/jsEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const getHeaderText = currentDialog => {
  switch (currentDialog) {
    case SHARE_EMAIL:
      return 'reporting-action-components.actions.emailReport.dialog.form.emailFormSection.emailMessageLabel';
    default:
      return 'reporting-action-components.actions.shareVia.dialog.form.formSection.messageLabel';
  }
};
const ShareMessageTextInput = () => {
  const {
    currentDialog,
    message,
    setMessage
  } = useControlsContext();
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: getHeaderText(currentDialog)
    }),
    children: /*#__PURE__*/_jsx(TextArea, {
      defaultValue: message,
      onChange: e => setMessage(getEventValue(e))
    })
  });
};
export default ShareMessageTextInput;